import {
    HttpContextToken,
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
    HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable } from 'rxjs';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';
import { SecurityService } from '@connect-services/client/services/security.service';
import { SnackBarService } from '@shared/client/services/snack-bar.service';

export type INTERCEPTOR_NAME =
    'httpErrorsInterceptor' | 'httpAcceptLanguageInterceptor' | 'httpApplicationNameInterceptor';
export const BYPASS_INTERCEPTOR = new HttpContextToken<INTERCEPTOR_NAME[]>(() => []);

export function httpErrorsInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const router = inject(Router);
    const securityService = inject(SecurityService);
    const snackBarService = inject(SnackBarService);

    if (
        request.context.has(BYPASS_INTERCEPTOR) &&
        request.context.get(BYPASS_INTERCEPTOR).includes('httpErrorsInterceptor')
    ) {
        return next(request);
    }

    return next(request).pipe(
        catchError((errorResponse: HttpErrorResponse) => {
            let i18nKey = 'errorDefault';

            if (errorResponse.status !== HttpStatusCode.Unauthorized) {
                switch (request.method) {
                    case 'GET':
                        i18nKey = 'errorGET';
                        break;
                    case 'PATCH':
                        i18nKey = 'errorPATCH';
                        break;
                    case 'PUT':
                        i18nKey = 'errorPUT';
                        break;
                    case 'POST':
                        i18nKey = 'errorPOST';
                        break;
                    default:
                        break;
                }
            }

            if (errorResponse.status === HttpStatusCode.Unauthorized) {
                securityService.logout();
                snackBarService.openErrorSnackBar(errorResponse.error.message);

                throw errorResponse;
            }

            if (errorResponse.status === HttpStatusCode.Forbidden) {
                router.navigate([RoutePathEnum.PROJECTS]);
                snackBarService.openErrorSnackBar(errorResponse.error.message);

                throw errorResponse;
            }

            snackBarService.openErrorSnackBar(i18nKey);

            throw errorResponse;
        }),
    );
}
